var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.101 32l-5.068-1.819v-7.427l5.068 1.726V32zm.93 0l5.067-1.818v-7.428l-5.067 1.726V32zm-5.477-9.802l5.13-1.444 4.755 1.534-4.756 1.614-5.129-1.704zm-1.486-.575L0 19.805v-7.428l5.068 1.726v7.52zm.93 0l5.067-1.818v-7.428l-5.068 1.726v7.52zM.52 11.82l5.129-1.444 4.756 1.534-4.756 1.614-5.13-1.704zm16.372 9.802l-5.068-1.818v-7.428l5.068 1.726v7.52zm.93 0l5.067-1.818v-7.428l-5.068 1.726v7.52zm-5.477-9.802l5.129-1.444 4.756 1.534-4.756 1.614-5.129-1.704zm10.58-.576l-5.068-1.817V2l5.068 1.726v7.52zm.93 0l5.067-1.817V2l-5.068 1.726v7.52zm-5.477-9.801L23.51 0l4.755 1.533-4.755 1.615-5.13-1.704zm16.373 9.801l-5.068-1.817V2l5.068 1.726v7.52zm.929 0l5.068-1.817V2L35.68 3.726v7.52zm-5.477-9.801L35.334 0l4.755 1.533-4.755 1.615-5.13-1.704",
    fill: "#F90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.139d07c4fbc9570b15ecf9c5452ecad0.svg";
export { ForwardRef as ReactComponent };